module.exports = __webpack_public_path__ + "static/media/hero.6b086c88.svg";